import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNetworkKey, getExtraPropertiesKey, getAuthMemberKey, getAuthTokenKey, } from '../../utils/keys';
export const useUpsertExtraProperty = (options) => {
    const { useMutationOptions } = options || {};
    const queryClient = useQueryClient();
    const { client } = useTribeClient();
    return useMutation(input => client.upsertExtraProperties(input), {
        onSettled: () => {
            queryClient.invalidateQueries(getNetworkKey());
            queryClient.invalidateQueries(getAuthMemberKey());
            queryClient.invalidateQueries(getAuthTokenKey());
            queryClient.invalidateQueries(getExtraPropertiesKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpsertExtraProperty.js.map